import React, { useState, ReactNode } from 'react';
import { Button } from 'components/shadcn/button';
import { Modal } from 'components/Shared/Modal/Modal';

interface ConfirmActionButtonProps {
  icon: ReactNode;
  dialogTitle: string;
  dialogText: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  buttonProps?: any;
}

const ConfirmActionButton: React.FC<ConfirmActionButtonProps> = ({
  icon,
  dialogTitle,
  dialogText,
  onConfirm,
  confirmLabel = 'Ja',
  cancelLabel = 'Abbrechen',
  buttonProps,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    handleClose();
    onConfirm();
  };

  return (
    <>
      <div onClick={handleOpen} {...buttonProps}>
        {icon}
      </div>

      <Modal isOpen={open} handleClose={handleClose} modalTitle={dialogTitle} message={dialogText}>
        <div className="px-8 gap-2 flex flex-col my-5">
          <Button onClick={handleConfirm}>{confirmLabel}</Button>
          <Button className="bg-secondary-btn" onClick={handleClose}>
            {cancelLabel}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ConfirmActionButton;
